// functions/importPlanJSON.jsx
export async function importPlanJSON(file) {
  const text = await file.text();
  const data = JSON.parse(text);
  return data; // enthält { items, info }
}
